export default defineNuxtRouteMiddleware((to, from) => {
  if (!from.name && to.path === '/error') {
    return navigateTo('/') // エラーページへの直接アクセスを防ぐ
  }
})